module.exports = __webpack_public_path__ + "img/suggests-illustrations.da8ce5e5.svg";